// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SidebarSection-module-sidebarSection {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.SidebarSection-module-sidebarSection > h1 {
  display: none;
}

.sidebar-open .SidebarSection-module-sidebarSection > h1 {
  display: block;
  color: gray;
  font-size: 0.8rem;
  text-transform: uppercase;
}

.SidebarSection-module-sidebarSection > ul {
  list-style: none;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/Router/App/components/SidebarSection/SidebarSection.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb","sourcesContent":[".sidebarSection {\r\n  width: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n}\r\n\r\n.sidebarSection > h1 {\r\n  display: none;\r\n}\r\n\r\n:global(.sidebar-open) .sidebarSection > h1 {\r\n  display: block;\r\n  color: gray;\r\n  font-size: 0.8rem;\r\n  text-transform: uppercase;\r\n}\r\n\r\n.sidebarSection > ul {\r\n  list-style: none;\r\n  padding: 0;\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 15px;\r\n  width: 100%;\r\n}"],"sourceRoot":""}]);
// Exports
export var sidebarSection = `SidebarSection-module-sidebarSection`;
export default ___CSS_LOADER_EXPORT___;
